import { render, staticRenderFns } from "./Zusatzangebote.vue?vue&type=template&id=023f9cbf"
import script from "./Zusatzangebote.vue?vue&type=script&lang=js"
export * from "./Zusatzangebote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports